import { REPORT_CHART_COLORS } from '../../../reports-components/chart-theme';

export const CHART_SERIES_IDS = Object.freeze({
  Beginning: 'beginning',
  Mrr: 'mrr',
  New: 'new',
  Expansion: 'expansion',
  Reactivation: 'reactivation',
  Contraction: 'contraction',
  Churn: 'churn',
  Ending: 'ending',
});

export const CHART_COLORS = Object.freeze({
  beginning: REPORT_CHART_COLORS.beginning,
  mrr: REPORT_CHART_COLORS.endingMrr,
  new: REPORT_CHART_COLORS.new,
  expansion: REPORT_CHART_COLORS.expansion,
  reactivation: REPORT_CHART_COLORS.reactivation,
  contraction: REPORT_CHART_COLORS.contraction,
  churn: REPORT_CHART_COLORS.churn,
  ending: REPORT_CHART_COLORS.ending,
});

export const SHOW_NET_NEW_MRR_LINE = false;
